import React, { useEffect, useState } from 'react';
import { Stack, Typography, Box, TextField, Button, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import mainLogo from '../../images/black_letters_with_blue_shadow.svg';
import resultsTeaser from '../../images/resultsTeaser.svg';
import Emoji from '../../assets/icons/index.js';
import './email.css';
import { useUserApi } from '../../api/user';

export const EmailPage = () => {
  const api = useUserApi();
  const navigate = useNavigate();

  const [ email, setEmail ] = useState( '' );
  const [ userCount, setUserCount ] = useState( null );
  const [ loading, setLoading ] = useState( true );
  const [ error, setError ] = useState( null );
  const [ isEmailReqSend, setIsEmailReqSend ] = useState( false );

  useEffect( () => {
    const fetchUserCount = async () => {
      try {
        const response = await api.getUserCount();
        if ( response && response.data && response.data.user_count ) {
          setUserCount( response.data.user_count );
          setLoading( false );
        } else {
          throw new Error( 'Invalid response format' );
        }
      } catch ( err ) {
        console.error( 'Error fetching user count:', err );
        setError( `Failed to fetch user count: ${ err.message }` );
        setLoading( false );
      }
    };

    fetchUserCount();
  }, [ api ] );

  const renderUserCount = () => {
    if ( loading ) return <div>Loading...</div>;
    if ( error ) return <Typography color="error"></Typography>;
    if ( userCount !== null ) {
      return <Typography>👇 { userCount.toLocaleString() } people just revealed their results 👇</Typography>;
    }
    return null;
  };

  return (
    <Box className="email-page-wrapper">
      <Stack className="email-card">
        <Box className="card-header" textAlign="center">
          <img src={ mainLogo } height={ 80 } alt="AI-MD Logo" className="aimd-logo" />
        </Box>

        <Box className="card-body">
          <Stack className="email-page bg-light" minHeight="440px">
            <Stack className="card-info" textAlign="center" marginTop="1rem">
              <Typography variant="h4" component="h4">
                Get Health Results <Emoji symbol="👀" label="eyes" />
              </Typography>
              <Typography variant="body1" component="p" className="info-txt" marginTop={ 1 }>
                Get instant access to your health insights, giving you clear and actionable health information to make
                informed decisions.

                <Box>
                  <img src={ resultsTeaser } alt="Results Teaser" />
                </Box>


                <Box className="user-count" color={ 'black' }>
                  { renderUserCount() }
                </Box>
                <TextField
                  sx={ { input: { textAlign: "left" } } }
                  className="custom-input-email"
                  label="Enter your email"
                  type="email"
                  variant="filled"
                  fullWidth
                  margin="normal"
                  value={ email }
                  onChange={ ( e ) => setEmail( e.target.value ) }
                />
              </Typography>
            </Stack>
          </Stack>
        </Box>

        <Stack display="flex" flexDirection="column" justifyContent="center" alignItems="center" marginTop={ 1 }>
          <Button
            onClick={ () => {
                  if (!email || !/\S+@\S+\.\S+/.test(email)) {
                      alert('Please enter a valid email address.');
                      return;
                  }
                  navigate( '/thank-you', { state: { email } } );
            } }
            disabled={!email }
            className="continue-btn"
          >
            Continue
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};